// components/RolesAndRights.tsx
import React, { useEffect } from 'react';
import { Box, Divider, ThemeProvider, Snackbar, Alert } from '@mui/material';
import { useRoles } from './hooks/useRoles';
import { useRights } from './hooks/useRights';
import { useErrorHandler } from '../utils/useErrorHandler';
import RolesSection from './components/RolesSection';
import RightsAssignmentSection from './components/RightsAssignment';
import theme from './theme';

const RolesAndRights = () => {
  const { snackbar, showSuccessMessage, handleErrorWithLogout, handleSnackbarClose } = useErrorHandler();

  const {
    roles,
    selectedRole,
    roleName,
    setRoleName,
    roleDescription,
    setRoleDescription,
    fetchRoles,
    createRole,
    updateRole,
    deleteRole,
    selectRole,
  } = useRoles(showSuccessMessage, handleErrorWithLogout);

  const {
    availableRights,
    setAvailableRights,
    assignedRights,
    setAssignedRights,
    selectedAvailableRights,
    setSelectedAvailableRights,
    selectedAssignedRights,
    setSelectedAssignedRights,
    fetchAllRights,
    moveToAssigned,
    moveToAvailable,
  } = useRights(selectedRole, showSuccessMessage, handleErrorWithLogout);

  useEffect(() => {
    const initializeData = async () => {
      await fetchRoles();
      await fetchAllRights();
    };
    initializeData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ p: 3 }}>
        <RolesSection
          roles={roles}
          selectedRole={selectedRole}
          roleName={roleName}
          setRoleName={setRoleName}
          roleDescription={roleDescription}
          setRoleDescription={setRoleDescription}
          onSelectRole={selectRole}
          onCreateRole={createRole}
          onUpdateRole={updateRole}
          onDeleteRole={deleteRole}
        />

        <Divider sx={{ my: 3 }} />

        <RightsAssignmentSection
          availableRights={availableRights}
          setAvailableRights={setAvailableRights}
          assignedRights={assignedRights}
          setAssignedRights={setAssignedRights}
          selectedAvailableRights={selectedAvailableRights}
          setSelectedAvailableRights={setSelectedAvailableRights}
          selectedAssignedRights={selectedAssignedRights}
          setSelectedAssignedRights={setSelectedAssignedRights}
          moveToAssigned={moveToAssigned}
          moveToAvailable={moveToAvailable}
        />

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </ThemeProvider>
  );
};

export default RolesAndRights;